import * as React from 'react';

function SvgSync(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M12.995 5.489a5.86 5.86 0 00-8.883 5.022M2.395 8.672l1.556 2.272 2.406-1.593M7.045 15.82a5.86 5.86 0 008.703-5.329"
        stroke={props.color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.544 12.205l-1.742-2.151-2.2 1.737"
        stroke={props.color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgSync;
